import { Avatar, AvatarSizes } from 'components/Avatar';
import Button from 'components/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MailIcon from './components/MailIcon';

interface Props {
  name: string;
  actions?: React.ReactNode | React.ReactNode[];
  avatar: string;
  title: string;
  email?: string;
}

const MemberCard = ({ name, actions, avatar, title, email }: Props) => {
  const { t } = useTranslation(['organizations']);
  
  return (
    <li className="flex items-center gap-3 w-[385px]">
      <Avatar src={avatar} size={AvatarSizes.X3l} />
      <div className="flex-1 font-normal text-lg">
        <p className="text-lg font-semibold text-black">{name}</p>
        <p className="text-base text-gray-500">{title}</p>
        {email && (
          <Button
            variant="primary"
            size="small"
            className="w-full max-w-[160px] bg-[#EFF2FF] flex gap-2"
            onClick={() => window.open(`mailto:${email}`, '_blank')}
          >
            <MailIcon />
            <p className="text-[#3853C4] font-semibold">{t('team.contact')}</p>
          </Button>
        )}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </li>
  );
};

export default MemberCard;
